export const createPaymentLinkPostData = (passData: any) => {
  let newData: Array<any> = []
  passData?.map((item: any) => {
    newData.push(Object.values(item)[0])
  })
  return newData
}
